<div class="field-group">
    <div>
        <mat-form-field class="field-medium">
            <mat-label>Début du traitement</mat-label>
            <input matInput [value]="treatment?.startDate" (dateChange)="treatment.startDate = $event.value" [matDatepicker]="pickerStart">
            <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="field-medium">
            <mat-label>Fin du traitement</mat-label>
            <input matInput [value]="treatment?.endDate" (dateChange)="treatment.endDate = $event.value" [matDatepicker]="pickerEnd">
            <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="field-medium">
            <mat-label>Nombre de séances</mat-label>
            <input matInput type="number" [value]="treatment?.sessionCount" (change)="setSessionCount($event.target.value)">
        </mat-form-field>
        <mat-form-field class="field-medium">
            <mat-label>Date prescription</mat-label>
            <input matInput [value]="treatment?.prescribedDate" (dateChange)="treatment.prescribedDate = $event.value" [matDatepicker]="pickerPrescribed">
            <mat-datepicker-toggle matSuffix [for]="pickerPrescribed"></mat-datepicker-toggle>
            <mat-datepicker #pickerPrescribed></mat-datepicker>
        </mat-form-field>
        <div style="display:inline-block;width:400px;">
            <app-user-selection style="margin-left: 20px;margin-top: 5px;" (selected)="treatment.prescriber = $event" [label]="'Prescripteur'" [user]="treatment?.prescriber" [mode]="'list'" [userClass]="'SNItem.SNUser.CNUser.CNHealthAgent'"></app-user-selection>
        </div>
    </div>  
</div>
<div class="field-group">
    <div>
        <mat-checkbox *ngFor="let index of sessionCounter" class="example-margin" [checked]="sessionCheck(index)" (change)="setSessionCheck(index, $event)">{{ index }}</mat-checkbox>
    </div>  
</div>
<div class="field-line">
    <mat-form-field class="field-full-width">
        <mat-label>Description</mat-label>
        <input matInput type="text" [value]="treatment?.description" (change)="treatment.description = $event.target.value">
    </mat-form-field>
</div>  
